import React from 'react'
import { Button, Grid, Typography } from '@material-ui/core'
import HighlightOffIcon from '@material-ui/icons/HighlightOff'
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'

export const OperacionEliminarFinDeLlenadoView = ({ silo: { nombreCorto: nombre }, aceptar, cancelar }) => (
  <Grid container spacing={4} direction='column' justify='space-around'>
    <Grid item xs={12}>
      <Typography variant='h6'>Atención</Typography>
    </Grid>
    <Grid item xs={12}>
      <Typography variant='h6'>¿Seguro que desea cancelar el último fin de llenado de <strong>{nombre}</strong>?</Typography>
    </Grid>
    <Grid container spacing={3} item xs={12} justify='space-between'>
      <Grid item xs='auto'>
        <Button
          variant='contained'
          onClick={cancelar}
          startIcon={<HighlightOffIcon />}
          color='secondary'>
          <Typography variant='button'>Cancelar</Typography>
        </Button>
      </Grid>
      <Grid item xs='auto'>
        <Button
          variant='contained'
          onClick={aceptar}
          startIcon={<CheckCircleOutlineIcon />}
          color='primary'>
          <Typography variant='button'>Aceptar</Typography>
        </Button>
      </Grid>
    </Grid>
  </Grid>
)
